import { dayjs, getTimezoneOffset } from '@vitvio/helpers';
import { essentialTimezones } from './data/essential-timezones';

export function getTimezoneWithOffset(timezoneName: string, description: string): string {
  const offset = getTimezoneOffset(timezoneName);
  return `${timezoneName} (UTC${offset}) ${description}`;
}

export function parseTimezones(timezonesWithDescriptions: { [key: string]: string }): { [key: string]: string } {
  return Object.entries(timezonesWithDescriptions).reduce(
    (acc, [timezone, description]) => {
      acc[timezone] = getTimezoneWithOffset(timezone, description);
      return acc;
    },
    {} as { [key: string]: string },
  );
}

export const parsedTimezones = parseTimezones(essentialTimezones);
